module.exports = __webpack_public_path__ + "img/lobby_hosting_smf2.b67ab927.png";